import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Input from "./Input";
import { SEARCH_PATH } from "../../../../constants/RoutesConstants";
import getSearchKeywordSelector from "../../../../state/selectors/SearchSelectors/getSearchKeywordSelector";
import setSearchKeywordAction from "../../../../state/actions/SearchActions/setSearchKeywordAction";
import { useRouteMatch } from "react-router";

const Search: React.FC = () => {
    const keyword = useSelector((state: Store) => getSearchKeywordSelector(state));
    const dispatch = useDispatch();
    const setSearchKeyword = useCallback((keyword: string) => dispatch(setSearchKeywordAction(keyword)), [dispatch]);
    const match = useRouteMatch({
        path: SEARCH_PATH,
        exact: true
    });
    const isSearchPage = Boolean(match);
    return <Input isSearchPage={isSearchPage} value={keyword} placeholder="Cerca..." onChange={setSearchKeyword} />;
};

export default Search;
